export enum TIMELINE_PERIOD {
  WEEK = 'week',
  DAY = 'day'
}

export const DEFAULT_PERIOD = TIMELINE_PERIOD.DAY;
